// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2O4Pe","addWidgetButton":"Header_addWidgetButton__1P1Cb","dashboardTabs":"Header_dashboardTabs__3IsGq","active":"Header_active__3gnqd"};